import { useTranslation } from "react-i18next";
import { StringSelect } from "@tellescope/ui";
import type { SpacerBlock } from "../../../../../shared/schema";
import { LayoutSection } from "../shared/LayoutSection";
import { VisibilitySection } from "../shared/VisibilitySection";
import type { BlockTypeEditorProps } from "../types";

type SpacerBlockEditorProps = BlockTypeEditorProps<SpacerBlock>;

export function SpacerBlockEditor({
  block,
  updateProps,
  updateLayout,
  updateVisibility,
  layoutOpen,
  setLayoutOpen,
  visibilityOpen,
  setVisibilityOpen,
}: SpacerBlockEditorProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <StringSelect
        label={t("Size")}
        value={block.props.size}
        onValueChange={(value) => updateProps({ size: value })}
        options={[
          { value: "sm", label: t("Small") },
          { value: "md", label: t("Medium") },
          { value: "lg", label: t("Large") },
          { value: "xl", label: t("Extra Large") },
        ]}
      />
      <LayoutSection layout={block.layout} onChange={updateLayout} open={layoutOpen} onOpenChange={setLayoutOpen} />
      <VisibilitySection
        visibility={block.visibility}
        onChange={updateVisibility}
        open={visibilityOpen}
        onOpenChange={setVisibilityOpen}
      />
    </div>
  );
}
